exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-flow: row nowrap;\r\n            flex-flow: row nowrap;\r\n    -webkit-box-pack: justify;\r\n        -ms-flex-pack: justify;\r\n            justify-content: space-between;\r\n    padding: 0 20px;\r\n\r\n    font-size: 1.5rem;\r\n}\r\n.menu_search {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 1 50%;\r\n            flex: 1 1 50%;\r\n}\r\n.menu__contacts {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 1 20%;\r\n            flex: 1 1 20%;\r\n}\r\n.menu__link {\r\n    color: inherit;\r\n    text-decoration: none;\r\n}\r\n.menu__user {\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 1 30%;\r\n            flex: 1 1 30%;\r\n\r\n    text-align: right;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/mailbox/menu/menu.component.css
// module id = 598
// module chunks = 1